import { render, staticRenderFns } from "./SwipeableBottomSheet.vue?vue&type=template&id=309512b1&scoped=true"
import script from "./SwipeableBottomSheet.vue?vue&type=script&lang=js"
export * from "./SwipeableBottomSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309512b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309512b1')) {
      api.createRecord('309512b1', component.options)
    } else {
      api.reload('309512b1', component.options)
    }
    module.hot.accept("./SwipeableBottomSheet.vue?vue&type=template&id=309512b1&scoped=true", function () {
      api.rerender('309512b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/SwipeableBottomSheet.vue"
export default component.exports